/**
 * Context Tags Component
 * GTD-style context filters (@phone, @email, @computer, @meeting)
 */

import React from "react";
import { Tag, Space } from "antd";
import {
  PhoneOutlined,
  MailOutlined,
  LaptopOutlined,
  TeamOutlined,
  HomeOutlined,
  ShopOutlined,
} from "@ant-design/icons";

export interface ContextTagsProps {
  selectedContexts: string[];
  onContextToggle: (context: string) => void;
}

const CONTEXTS = [
  { value: "@phone", label: "phone", icon: <PhoneOutlined /> },
  { value: "@email", label: "email", icon: <MailOutlined /> },
  { value: "@computer", label: "computer", icon: <LaptopOutlined /> },
  { value: "@meeting", label: "meeting", icon: <TeamOutlined /> },
  { value: "@office", label: "office", icon: <ShopOutlined /> },
  { value: "@home", label: "home", icon: <HomeOutlined /> },
];

export const ContextTags: React.FC<ContextTagsProps> = ({
  selectedContexts,
  onContextToggle,
}) => {
  return (
    <Space size={4} wrap>
      {CONTEXTS.map((ctx) => (
        <Tag
          key={ctx.value}
          icon={ctx.icon}
          color={selectedContexts.includes(ctx.value) ? "purple" : undefined}
          style={{ cursor: "pointer", margin: 0 }}
          onClick={() => onContextToggle(ctx.value)}
        >
          {ctx.label}
        </Tag>
      ))}
    </Space>
  );
};
